export const isSamePlayer = (fullName, shortName) => {
  if (!fullName || !shortName) return false;

  const full = String(fullName).toLowerCase().trim();
  const short = String(shortName).toLowerCase().trim();

  if (full === short) return true;

  const fullParts = full.split(" ");
  const shortParts = short.split(" ");

  const fullLastName = fullParts[fullParts.length - 1];
  const shortLastName = shortParts[shortParts.length - 1];

  if (fullLastName === shortLastName) {
    if (fullParts[0][0] === shortParts[0][0]) {
      return true;
    }
  }

  return false;
};

const normalizeIdentity = (value) => {
  if (value === null || value === undefined) return null;
  const normalizedValue = String(value).trim();
  return normalizedValue || null;
};

// Safely extract an ID, falling back to other properties if needed
export const getPlayerId = (player) => {
  if (!player) return null;

  if (typeof player !== "object") {
    return normalizeIdentity(player);
  }

  return normalizeIdentity(
    player.playerId ||
      player.player_id ||
      player.id ||
      player._id ||
      player.pid ||
      player.key ||
      player.event_player_key ||
      player.name ||
      player.playerName ||
      player.player_name
  );
};

// Find a player in a list by ID or by using the smart name matcher
export const getPlayerById = (idOrName, playersList) => {
  const players = Array.isArray(idOrName) ? idOrName : playersList;
  const target = Array.isArray(idOrName) ? playersList : idOrName;

  if (!players || !Array.isArray(players)) return null;

  const targetId = getPlayerId(target);
  const targetName =
    typeof target === "object"
      ? target?.name || target?.playerName || target?.player_name
      : target;

  return players.find((player) =>
    (targetId && getPlayerId(player) === targetId) ||
    isSamePlayer(player?.name || player?.playerName || player?.player_name, targetName)
  );
};

// Resolve an ID from a selection, ensuring we get a valid identifier
export const resolvePlayerSelectionId = (selection, playersList) => {
  if (selection && typeof selection === "object" && !Array.isArray(selection)) {
    const players = selection.players || playersList || [];
    const directPlayer =
      getPlayerById(selection.playerId, players) ||
      getPlayerById(selection.player, players);

    if (directPlayer) return getPlayerId(directPlayer);

    const directId = getPlayerId(selection.playerId || selection.player);
    if (directId) return directId;

    const legacyIndex = Number(selection.playerIndex);
    if (Number.isInteger(legacyIndex) && players[legacyIndex]) {
      return getPlayerId(players[legacyIndex]);
    }

    return null;
  }

  const player = getPlayerById(selection, playersList);
  return player ? getPlayerId(player) : getPlayerId(selection);
};

// Standardize a list of players
export const normalizePlayerList = (players) => {
  if (!players || !Array.isArray(players)) return [];
  return players.map(p => ({
    ...p,
    _normalizedId: getPlayerId(p)
  }));
};

// Standardize team selections
export const normalizeTeamSelection = (teamSelection) => {
  if (!teamSelection) return [];
  if (Array.isArray(teamSelection)) return normalizePlayerList(teamSelection);
  if (teamSelection.players) return { ...teamSelection, players: normalizePlayerList(teamSelection.players) };
  return teamSelection;
};
